function AmenitiesAndBook({ amenities, bookingQuantity, cancelable }) {
  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white rounded-2xl shadow-xl p-6 transform transition-all  border border-gray-100">
        <h2 className="text-2xl font-bold mb-4 text-gray-800 tracking-tight">
          Saha Bilgileri
        </h2>

        <div className="mb-3">
          {cancelable.isCancelable ? (
            <p className="text-gray-600">
              <span className="text-[#4d9041]">✓</span> You can cancel your
              reservation{" "}
              <span className="font-semibold text-[#4d9041]">
                {cancelable.string}
              </span>
            </p>
          ) : (
            <p className="text-gray-600 flex items-center">
              <span className="text-red-500">✗</span>
              <span className="ml-2">İptal edilemez.</span>
            </p>
          )}
          <p className="mt-3">
            Bu saha <span className="font-semibold">{bookingQuantity}</span>{" "}
            kere kullanıcılar tarafından tercih edildi.
          </p>
        </div>

        <h3 className="text-lg font-semibold mb-3 text-gray-800">Olanaklar</h3>
        <ul className="space-y-3">
          {amenities.map((amenity, index) => (
            <li
              key={index}
              className="flex items-center space-x-3 text-gray-600"
            >
              <span className="flex-shrink-0 w-6 h-6 bg-[#4d9041]/10 rounded-full flex items-center justify-center">
                <span className="text-[#4d9041] text-sm">✔</span>
              </span>
              <span className="text-gray-700">{amenity}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AmenitiesAndBook;
